import React, { useEffect, useState } from "react";
import { Data } from "../profile/Dashboardarray";
import cross from "../assets/cross.png";
import tick from "../assets/tick.png";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {setThirdPage} from "../../store/addBusinessSlice";
import {useGetkeywordsMutation} from "../../services/api";
import { WithContext as ReactTags } from "react-tag-input";
import "./Steppers.css";


const KeyCodes = {
  comma: 188,
  enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

function Detail() {
  const [getkeywords, { isLoading, isError }] = useGetkeywordsMutation();
  
  const [state, setstate] = useState(Data);
  const [tags, setTags] = useState([]);
  const [keywords, setKeywords] = useState([]);
const [allKeywords, setAllKeywords] = useState([]);
  const [thirdPageData, setThirdPageData] = useState({
    businessDescription: "",
    dateAndTime: [],
  });
  const dispatch = useDispatch();
  

  const navigate = useNavigate();

  useEffect(() => {
    getkeywords().unwrap()
    .then((payload) => {
      console.log("payload",payload);
      setAllKeywords(payload);
      // dispatch(setKeywords(payload));
      
    })
    .catch((error) => {
      console.log(error);
     
    });
  }, []);

  const handleOnChange = (e) => {
    setThirdPageData({ ...thirdPageData, [e.target.name]: e.target.value });
  };

  // This is the code for selecting data for different day:
  const [timeData, setTimeData] = useState([
    {
      day: "mon",
      open_time: "None",
      close_time: "None",
      closed: false,
    },
    {
      day: "tue",
      open_time: "None",
      close_time: "None",
      closed: false,
    },
    {
      day: "wed",
      open_time: "None",
      close_time: "None",
      closed: false,
    },
    {
      day: "thu",
      open_time: "None",
      close_time: "None",
      closed: false,
    },
    {
      day: "fri",
      open_time: "None",
      close_time: "None",
      closed: false,
    },
    {
      day: "sat",
      open_time: "None",
      close_time: "None",
      closed: false,
    },
    {
      day: "sun",
      open_time: "None",
      close_time: "None",
      closed: false,
    },
  ]);

  const handleOpenChange = (event, index) => {
    const newTimeData = [...timeData];
    newTimeData[index].open_time = event.target.value + ":00";
    setTimeData(newTimeData);
  };

  const handleCloseChange = (event, index) => {
    const newTimeData = [...timeData];
    newTimeData[index].close_time = event.target.value + ":00";
    setTimeData(newTimeData);
  };

  const handleClosedChange = (event, index, text) => {
    if (text === "close") {
      const newTimeData = [...timeData];
      newTimeData[index].closed = true;
      setTimeData(newTimeData);
    } else {
      const newTimeData = [...timeData];
      newTimeData[index].closed = false;
      setTimeData(newTimeData);
    }
  };

  const handleLogData = () => {
    console.log(timeData);
  };

  // Navigating to the next page:

  const handlepress = () => {
    // const tagsText = tags.map((elem) => {
    //   return elem.text;
    // });

    dispatch(
      setThirdPage({ ...thirdPageData, tags: tags, dateAndTime: timeData, keywords:allKeywords })
    );
    navigate("/video");
  };

  useEffect(() => {
    console.log("allKeywords: ", allKeywords);
    const keyword_pk = allKeywords?.map((elem) => {
      return elem?.id;
    });
    setTags(keyword_pk);
    setKeywords(
      allKeywords?.map((elem) => {
        return elem?.keywords;
      })
    );
  }, [allKeywords]);

  return (
    <>
      <div className="d-flex align-items-center ps-3 pe-3 pb-5 pt-5 mb-5">
        <div className="container box_div" style={{ position: "relative" }}>
          <div className="steper_div">
            <div className="num">
              <img className="tick_img" src={tick} />
            </div>
            <div className="border_bottom_div"></div>
            <div className="num">
              <img className="tick_img" src={tick} />
            </div>
            <div className="border_bottom_div"></div>
            <div className="num">
              <p>3</p>
            </div>
            <div className="border_bottom2_div"></div>
            <div className="num2">
              <p>4</p>
            </div>
          </div>
          <div className="d-flex justify-content-center ">
            <div className="card_business">
              <div>
                <p className="business_heading1_main ">Add Business Detail</p>
                <p className="label1">Business Description</p>
                <div style={{ position: "relative" }}>
                  <textarea
                    className="textarea"
                    placeholder="Description..."
                    name="businessDescription"
                    value={thirdPageData.businessDescription}
                    onChange={handleOnChange}
                  ></textarea>
                  <p className="numbering">
                    10<span className="text">/750</span>
                  </p>
                </div>
                <p className="label1">
                  {" "}
                  Add up to 10 key words
                  <span className="span_txt"> ( Max 30 letters/keyword) </span>
                </p>
                <div className="input1 ps-2 pe-2 pb-2">
                  <div className="d-flex gap-1 flex-wrap">
                    {keywords &&
                      keywords.map((elem) => {
                        return (
                          <div className="badge_main">
                            <p>{elem}</p>
                            <div className="badge_inner">
                              <img src={cross} />
                            </div>
                          </div>
                        );
                      })}
                    {/* <div className="badge_main">
                      <p>Business</p>
                      <div className="badge_inner">
                        <img src={cross} />
                      </div>
                    </div>
                    <div className="badge_main">
                      <p>Mesa</p>
                      <div className="badge_inner">
                        <img src={cross} />
                      </div>
                    </div>
                    <div className="badge_main">
                      <p>Mesa</p>
                      <div className="badge_inner">
                        <img src={cross} />
                      </div>
                    </div> */}
                  </div>
                  {/* <ReactTags
                    tags={tags}
                    delimiters={delimiters}
                    handleDelete={handleDelete}
                    handleAddition={handleAddition}
                    handleDrag={handleDrag}
                    handleTagClick={handleTagClick}
                    inputFieldPosition="bottom"
                  /> */}
                </div>
                <p className="label1">
                  Select your business working days and hours
                </p>
                {timeData.map((value, index) => {
                  return (
                    <div
                      className="d-flex align-items-center justify-content-between time-parent"
                      style={{ overflow: "hidden" }}
                      key={index}
                    >
                      <div className="day_div">
                        <p className="day">{value.day.toUpperCase()}</p>
                        <div>
                          <p
                            onClick={(e) =>
                              handleClosedChange(e, index, "open")
                            }
                            className={!value.closed ? "status" : "status1"}
                          >
                            Open
                          </p>
                          <p
                            onClick={(e) =>
                              handleClosedChange(e, index, "close")
                            }
                            className={value.closed ? "status" : "status1"}
                          >
                            Close
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center justify-content-between seconed_main">
                        <div className="day2_div">
                          <div>
                            {/* <p className="times">{value.time}</p> */}
                            <input
                              type="time"
                              value={value.open_time}
                              onChange={(event) =>
                                handleOpenChange(event, index)
                              }
                              className="mb-2 time-input"
                            />
                            <div className="hour_div">
                              <p>00:00</p>
                            </div>
                          </div>

                          <div>
                            <p className="mode">{value.mode1}</p>
                            <p className="mode1">{value.mode2}</p>
                          </div>
                        </div>
                        <p className="mt-4">-</p>
                        <div className="day2_div">
                          {/* <p className="times">{value.time2}</p> */}

                          <input
                            type="time"
                            value={value.close_time}
                            onChange={(event) =>
                              handleCloseChange(event, index)
                            }
                            className="mb-2 time-input"
                          />
                          <div>
                            <p className="mode">{value.mode1}</p>
                            <p className="mode1">{value.mode2}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div>
                  <div className="code_btn" onClick={handlepress}>
                    <button
                      className="next_btn mb-5"
                      style={{ marginBottom: "0px" }}
                    >
                      NEXT
                    </button>
                  </div>
                  <div className="bac_div bac2_div">
                    <p className="back_text">Back</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Detail;
